import WMSCapabilities from 'wms-capabilities'
import axios from "axios"
import LeafletServices from "@/services/leaflet.service";
import * as layerSettings from "@/settings/wms.settings"
import TimeSettings from "@/utils/wmsUtils";

const WmsCapabilities = {
    getLayerFromCapabilities: function(wmsCapabilities, layerName){
        return wmsCapabilities.Capability.Layer.Layer.filter(layer => layer.Name === layerName)[0]
    },

    getLayerFromCapabilities_jki: function(wmsCapabilities, layerName){
        let year = layerName.split("_")[2];
        return wmsCapabilities.Capability.Layer.Layer.filter(layer => layer.Name === year)[0].Layer[0].Layer.filter(layer => layer.Name === layerName)[0]
    },

    getJson: async baseUrl => {
        const capabilitiesUrl = baseUrl + "VERSION=1.3.0&REQUEST=GetCapabilities&SERVICE=WMS";
        const capabilitiesXml = (await axios.get(capabilitiesUrl)).data;
        return new WMSCapabilities().parse(capabilitiesXml)
    },

    createWmsLayerList: function () {
        const opacity = 100;
        let wmsLayerList = [];

        layerSettings.default.forEach(service => {
            service.layer.forEach(layer => {
                let leafletLayer = LeafletServices.createWmsLeafletLayer(service, layer, opacity);

                wmsLayerList.push({
                    name: layer.name,
                    title: layer.title,
                    service: service.service,
                    baseUrl: service.baseUrl,
                    styleSettings: layer.multipleStyles,
                    timeSettings: layer.dimension,
                    styles: null,
                    times: null,
                    loading: true,
                    active: false,
                    opacity: opacity,
                    layer: leafletLayer,
                    selectedStyle: null,
                    selectedTime: null,
                    description: layer.description,
                    category: layer.category
                })
            })
        });

        return wmsLayerList
    },

    getStyles: function (wmsCapabilities, layer) {
        let layerObject;

        if (layer.service === "jki_mosaik"){
            layerObject = WmsCapabilities.getLayerFromCapabilities_jki(wmsCapabilities, layer.name)
        }
        else {
            layerObject = WmsCapabilities.getLayerFromCapabilities(wmsCapabilities, layer.name)
        }
        return layerObject.Style
    },

    getTime: function (wmsCapabilities, layerName, timeSettings) {
        const layerObject = WmsCapabilities.getLayerFromCapabilities(wmsCapabilities, layerName);

        if (timeSettings === "daily") {
            return TimeSettings.EntriesPerSingleDate(layerObject.Dimension[0].values)
        }
        else if (timeSettings === "monthly") {
            return TimeSettings.MonthlyValues(layerObject.Dimension[0].values)
        }
        else if (timeSettings === "yearly") {
            return TimeSettings.YearlyValues(layerObject.Dimension[0].values)
        }
    },

    getDescription: function (wmsCapabilities, layer) {
        let layerObject;

        if (layer.service === "jki_mosaik"){
            layerObject = WmsCapabilities.getLayerFromCapabilities_jki(wmsCapabilities, layer.name)
        }
        else {
            layerObject = WmsCapabilities.getLayerFromCapabilities(wmsCapabilities, layer.name)
        }

        return layerObject.Abstract
    }
};

export default WmsCapabilities